import { render, staticRenderFns } from "./message-bution.vue?vue&type=template&id=6a8fc23e&scoped=true"
import script from "./message-bution.vue?vue&type=script&lang=ts"
export * from "./message-bution.vue?vue&type=script&lang=ts"
import style0 from "./message-bution.vue?vue&type=style&index=0&id=6a8fc23e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8fc23e",
  null
  
)

export default component.exports